import React from 'react';
import {
	useStripe,
} from '@stripe/react-stripe-js';

import type CK from '~/types/contentking';

import {
	useRefreshPaymentStatusMutation,
} from './useResolvePaymentStatus.gql';

import useLoadPaymentStatus from '~/hooks/useLoadPaymentStatus';



type ReturnType = () => Promise<void>;



function useResolvePaymentStatus(accountId: CK.AccountId): ReturnType {
	const loadPaymentStatus = useLoadPaymentStatus();

	const stripe = useStripe();

	const [refreshPaymentStatus] = useRefreshPaymentStatusMutation();

	return React.useCallback(
		async () => {
			if (stripe === null) {
				return;
			}

			const paymentStatus = await loadPaymentStatus(accountId);

			const clientSecret = paymentStatus?.stripeAction?.clientSecret ?? null;

			if (clientSecret !== null) {
				await stripe.confirmCardPayment(clientSecret);

				await refreshPaymentStatus({
					variables: {
						accountId,
					},
				});
			}
		},
		[
			accountId,
			refreshPaymentStatus,
			loadPaymentStatus,
			stripe,
		],
	);
}



export default useResolvePaymentStatus;
